import { render, staticRenderFns } from "./old-account.vue?vue&type=template&id=5c2b433b&scoped=true&"
import script from "./old-account.vue?vue&type=script&lang=js&"
export * from "./old-account.vue?vue&type=script&lang=js&"
import style0 from "./old-account.vue?vue&type=style&index=0&id=5c2b433b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b433b",
  null
  
)

export default component.exports